/**
 * Graph Explorer - Simplified home view.
 *
 * Layout:
 * - Main area: Visualizer fills the full area
 * - No focus mode panel — relationships are shown upfront as grouped nodes
 *
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';
import { css, jsx } from '@atlaskit/css';

import { useGraphQLSchemaLoader } from '../../../state/useGraphQLSchemaLoader';

import { ObjectsVisualizer } from './ObjectsVisualizer';

const containerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- viewport calculation
	height: 'calc(100vh - 56px)' as any,
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- dark theme override (Primary Black per Figma "Explorer Light")
	backgroundColor: '#101214' as any,
});

/** Main content area. */
const mainContentStyles = css({
	display: 'flex',
	flex: 1,
	overflow: 'hidden',
	minHeight: '0px',
	position: 'relative',
});

const visualizerContainerStyles = css({
	flex: 1,
	minWidth: '0px',
	height: '100%',
});

// TODO: Possibly add a ErrorBoundary wrapping the entire page?
const GraphExplorerPageInternal = (): JSX.Element => {
	useGraphQLSchemaLoader();

	// No-op callback — kept for API compatibility with ObjectsVisualizer
	const handleExplorationStart = useCallback(() => {
		// No-op in simplified view
	}, []);

	return (
		<div css={containerStyles}>
			<div css={mainContentStyles}>
				<div css={visualizerContainerStyles}>
					<ObjectsVisualizer onExplorationStart={handleExplorationStart} />
				</div>
			</div>
		</div>
	);
};

const GraphExplorerPage = (): JSX.Element => {
	return (
		<AnalyticsContext data={{ attributes: { location: 'graphExplorer', page: 'graphExplorer' } }}>
			<GraphExplorerPageInternal />
		</AnalyticsContext>
	);
};

export default GraphExplorerPage;
